// Employer-route wrapper. Resolves the current user's clientId from session
// and delegates the actual UI to the tenant-scoped panel. The same panel is
// reused on the broker's ClientDetail Payroll tab (which sources clientId
// from the URL `:id` instead).

import { useQuery } from "@tanstack/react-query";
import ClientPayrollSettings from "@/components/payroll/ClientPayrollSettings";

export default function Payroll() {
  const { data: user } = useQuery<any>({ queryKey: ["/api/auth/user"] });
  const clientId = user?.clientId;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Payroll</h1>
        <p className="text-muted-foreground">
          Configure pay groups and manage payroll integrations
        </p>
      </div>
      <ClientPayrollSettings clientId={clientId} />
    </div>
  );
}
